import { Chart } from '@frontend/chart/types';

export const PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_MOCK_DATA: Chart = {
    series: [
        {
            name: '30×40×50',
            data: [{ label: 'full_period', value: 42 }]
        },
        {
            name: '40×50×60',
            data: [{ label: 'full_period', value: 31 }]
        },
        {
            name: '50×60×70',
            data: [{ label: 'full_period', value: 18 }]
        },
        {
            name: '60×80×90',
            data: [{ label: 'full_period', value: 9 }]
        }
    ]
};
